<template>
  <md-toolbar
    id="enquiry_customer_header"
    md-elevation="0"
    class="md-transparent"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start" v-if="enquiry">
        <div>
          <div class="md-headline">
            <router-link
              :to="{
                name: 'Customer Profile',
                params: { id: enquiry.customer.id }
              }"
              >{{ enquiry.customer.full_name }}
            </router-link>
          </div>
          <div class="md-body-1">
            <span v-show="enquiry.customer.email"
              ><md-icon class="md-primary">alternate_email</md-icon>
              <a :href="`mailto:${enquiry.customer.email}`">
                {{ enquiry.customer.email }}</a
              ></span
            >
            <span v-show="enquiry.customer.tel_num"
              ><md-icon class="md-primary">phone</md-icon>
              {{ enquiry.customer.tel_num }}</span
            >
            <span v-show="enquiry.customer.cell_num"
              ><md-icon class="md-primary">phone_iphone</md-icon>
              {{ enquiry.customer.cell_num }}</span
            >
          </div>
        </div>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          v-if="isOngoing"
          @click="$emit('outcomeDialog')"
          class="md-raised md-primary mt-4 manage-outcome-btn"
          >Manage Outcome</md-button
        >
        <md-button
          v-else
          @click="$emit('reactivateEnquiry')"
          class="md-raised md-success mt-4 reactivate-enquiry-btn"
          >Re-Activate</md-button
        >

        <div v-if="enquiry.manager" class="mt-4">
          <manager-dropdown
            v-model="enquiry.manager.id"
            @input="managerSelected"
          />
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import enquiryApi from "@/services/api/enquiry";
import ManagerDropdown from "@/components/Handi/Users/ManagerDropdown.vue";

export default {
  data() {
    return {};
  },

  props: ["enquiry"],

  components: {
    ManagerDropdown
  },

  computed: {
    isOngoing() {
      return this.enquiry.status.value == "ongoing";
    }
  },

  methods: {
    managerSelected(managerId) {
      enquiryApi
        .updateEnquiry({
          setmanager: true,
          id: this.enquiry.id,
          manager: {
            id: managerId
          }
        })
        .then(response => {
          this.$notify({
            timeout: 2500,
            message: "The Manager has been assigned.",
            icon: "thumb_up",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        })
        .catch(error => {});
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

#enquiry_customer_header {
  .md-toolbar-row {
    padding: 0 0 15px 0;
    margin-bottom: 1rem;
    border-bottom: 1px solid $brand-primary;
  }

  span {
    display: inline-block;
    margin-right: 1rem;
  }

  .md-headline {
    margin-bottom: 0.5rem;
  }

  .manage-outcome-btn,
  .reactivate-enquiry-btn {
    margin-right: 20px;
  }
}
</style>
